import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import axios from "axios";
import MaterialTable from "material-table";
import { Component } from "react";
import { Button, Form, Modal, Nav, OverlayTrigger, Tab, Tooltip } from "react-bootstrap";
import { FaCheckCircle, FaHourglassHalf, FaTimesCircle } from 'react-icons/fa';
import ConfirmModal from "../../utils/ConfirmModal";
import ExpenseVoucherPDF from "../../utils/ExpenseVoucherPDF";
import { hasPermission } from "../../utils/usePermission";
import CommonLoader from "../loaderComponent/CommonLoader";
import CommonToast from "../Toaster/CommonToast";
export default class ExpenseHeaderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGeneratingPDF: false,
      selfExpenses: [],
      reporteeExpenses: [],
      loading: true,
      activeTab: "self",
      showModal: false,
      selectedExpense: null,
      newStatus: "",
      showToast: false,
      toastMessage: "",
      empType: "",
      toastVariant: "",
      color: "",
      pdfData: null,
      showPdfComponent: false,
      expDataByExpId: [],
      pendingAmount: '',
      showConfirm: false,
      deleteId: null,
    };
  }

  componentDidMount() {
    this.fetchExpenseHeaders();
    this.fetchExpenseHeadersReportee();
    // this.fetchPendingAmount()
  }

  openConfirmModal = () => {
    this.setState({ showConfirm: true, });
  };
  closeConfirmModal = () => {
    this.setState({ showConfirm: false });
  };

  fetchExpenseHeaders = () => {
    this.setState({ loading: true });
    axios.get("/expenseHeader/list", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((res) => {
      console.log("API Response:", res.data);
      const allExpenses = res.data;

      this.setState({
        selfExpenses: allExpenses,
        loading: false
      });
    }).catch((error) => {
      console.error("Error fetching data:", error);
      this.setState({ loading: false });
    });
  };

  fetchExpenseHeadersReportee = () => {
    this.setState({ loading: true });
    axios.get("/expenseHeader/reportee-expenses", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((res) => {
      console.log("API Response:", res.data);
      const allReporteeExpenses = res.data;

      this.setState({// Now fetching same data for both
        reporteeExpenses: allReporteeExpenses,
        loading: false
      });
    }).catch((error) => {
      console.error("Error fetching data:", error);
      this.setState({ loading: false });
    });
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };



  handleViewClick = (data) => {
    this.props.history.push({
      pathname: `/expense-header-details/${data.id}`,
      state: { data, viewPage: true, editAction: false }
    });
  };


  handleEditClick = (data) => {
    this.props.history.push({
      pathname: `/expense-header-details/${data.id}`,
      state: { data, editAction: true }
    });
  };

  handleStatusChange = (data) => {
    this.setState({ showModal: true, selectedExpense: data, newStatus: data.status });
  };

  handleStatusUpdate = () => {
    // debugger
    const { selectedExpense, newStatus } = this.state;
    if (newStatus !== 'Approved' && newStatus !== 'Rejected') {
      this.setState({ showToast: true, toastMessage: "Please select a status!", toastVariant: "danger", color: 'red' });
      return;
    }
    // if (newStatus !== 'Approved' || newStatus !== 'Rejected') {
    //   this.setState({ showToast: true, toastMessage: "Please select a status!", toastVariant: "danger" });
    //   return;
    // }
    axios.put(`/expenseHeader/status/${selectedExpense?.id}`, { status: newStatus }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then(() => {
      this.setState({ showToast: true, toastMessage: "Status updated successfully!", toastVariant: "success", color: 'green', showModal: false });
      this.fetchExpenseHeadersReportee();
    }).catch(() => {
      this.setState({ showToast: true, toastMessage: "Failed to update status!", toastVariant: "danger", color: 'red' });
    });
  };

  fetchPendingAmount = (empId, callback) => {
    axios.get(`financialInformations/advances/${empId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((res) => {
        const pendingAmount = res.data;
        this.setState({ pendingAmount }, () => {
          if (callback) callback(pendingAmount);
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        if (callback) callback(null);
      });
  };

  fetchExpenseDetailsByExpId = (expId, callback) => {
    this.setState({ loading: true });
    axios({
      method: 'get',
      url: `/expenseDetails/list/${expId}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState(
          { expDataByExpId: res.data?.data, loading: false },
          () => {
            if (callback) callback();
          }
        );
      })
      .catch(err => {
        this.setState({ loading: false });
        this.setState({ showToast: true, toastMessage: "No expense details found!", toastVariant: "danger", color: 'red' });
        console.log("error is here", err);
      });
  };


  handlePdfDownload = (rowData, empType) => {
    console.log("first", rowData, empType)


    this.setState({ loading: true });
    const { tableData, ...cleanData } = rowData;
    const empId = cleanData.empid;
    this.setState({ isGeneratingPDF: true });

    this.fetchPendingAmount(empId, (pendingAmount) => {
      this.fetchExpenseDetailsByExpId(cleanData.id, () => {
        this.setState({
          showPdfComponent: true,
          pdfData: cleanData,
          empType: empType,
          pendingAmount: pendingAmount,
          loading: false,
        });
      });
    });
  };

  //   this.fetchExpenseDetailsByExpId(cleanData.id, () => {
  //     this.setState({
  //       showPdfComponent: true,
  //       pdfData: cleanData,
  //       empType: empType,
  //       isGeneratingPDF: true
  //     });
  //   });
  // };
  handleAddExpense = () => {
    this.props.history.push('/add-expense-header')
  }


  handleDelete = () => {
    debugger;
    console.log("this.state.deleteId", this.state.deleteId)
    this.setState({ loading: true });
    const token = localStorage.getItem("token");
    axios
      .delete(`/expenseHeader/${this.state.deleteId} `, { headers: { Authorization: `Bearer ${token} ` } })
      .then(() => {
        this.setState({
          showConfirm: false,
          showToast: true,
          toastMessage: "Expense Header deleted successfully",
          toastVariant: "success",
          deleteId: null,
          color: 'green',
          loading: false,
        });
        this.fetchExpenseHeaders();
        this.fetchExpenseHeadersReportee();
      })
      .catch((error) => {
        this.setState({
          showToast: true,
          toastMessage: error.response?.data?.message || "Error deleting Expense Header",
          toastVariant: "danger",
          color: 'red',
          showConfirm: false,
          deleteId: null,
          loading: false,
        });
      });
  };

  renderTable = (expenses) => {
    return (
      <ThemeProvider theme={createTheme()}>
        <MaterialTable
          columns={[
            { title: "ID", field: "id" },
            { title: "Emp ID", field: "empid" },
            {
              title: "Full Name", field: "fullName",
              cellStyle: { minWidth: 250 },
              headerStyle: { minWidth: 250 }
            },
            {
              title: "Project", field: "project_name",
              cellStyle: { minWidth: 250 },
              headerStyle: { minWidth: 250 }
            },
            { title: "Total Amount", field: "total_amount" },
            { title: "Trip Balance", field: "tripBalance" },
            {
              title: "Status",
              field: "status",
              // render: rowData => (
              //   <Badge variant={rowData.status === "Approved" ? "success" : rowData.status === "Pending" ? "warning" : "danger"}>
              //     {rowData.status}
              //   </Badge>
              // ),
              // render: (rowData) => {
              //   const status = rowData.status?.toLowerCase();
              //   const getStatusStyles = (status) => {
              //     switch (status) {
              //       case "approved":
              //         return {
              //           backgroundColor: '#d1e7dd',
              //           color: '#0f5132',
              //           border: '1px solid #badbcc'
              //         };
              //       case "pending":
              //         return {
              //           backgroundColor: '#fff3cd',
              //           color: '#664d03',
              //           border: '1px solid #ffe69c',
              //         };
              //       case "rejected":
              //       default:
              //         return {
              //           backgroundColor: "#FBEAEA",
              //           color: '#842029',
              //           border: "1px solid #F1B5B5",
              //         };
              //     }
              //   };

              //   const styles = {
              //     display: 'inline-flex',
              //     alignItems: 'center',
              //     gap: '6px',
              //     fontSize: "0.75rem",
              //     padding: '4px 12px',
              //     borderRadius: '20px',
              //     fontWeight: 500,
              //     textTransform: "uppercase",
              //     minWidth: "80px",
              //     textAlign: "center",
              //     ...getStatusStyles(status),
              //   };

              //   return <span style={styles}>{rowData.status}</span>;
              // }
              render: (rowData) => {
                const status = rowData.status?.toLowerCase();

                const getStatusStyles = (status) => {
                  switch (status) {
                    case "approved":
                      return {
                        backgroundColor: '#d1e7dd',
                        color: '#0f5132',
                        border: '1px solid #badbcc',
                        icon: <FaCheckCircle />,
                      };
                    case "pending":
                      return {
                        backgroundColor: '#fff3cd',
                        color: '#664d03',
                        border: '1px solid #ffe69c',
                        icon: <FaHourglassHalf />,
                      };
                    case "rejected":
                    default:
                      return {
                        backgroundColor: "#f8d7da",
                        color: '#842029',
                        border: "1px solid #f5c2c7",
                        icon: <FaTimesCircle />,
                      };
                  }
                };

                const { icon, ...styleProps } = getStatusStyles(status);

                const styles = {
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: "0.75rem",
                  padding: '4px 12px',
                  borderRadius: '20px',
                  fontWeight: 500,
                  textTransform: "uppercase",
                  minWidth: "90px",
                  textAlign: "center",
                  ...styleProps,
                };

                return (
                  <span style={styles}>
                    {icon} {rowData.status}
                  </span>
                );
              }

            },
            {
              title: "Actions",
              field: "actions",
              render: rowData => (
                <>

                  {hasPermission('M15S2B1') && (
                    <>
                      <OverlayTrigger placement="top" overlay={<Tooltip>View Details</Tooltip>}>
                        <Button size="sm"
                          className='info mr-2'
                          variant="outline-info" onClick={() => this.handleViewClick(rowData)}>
                          <i className="fas fa-eye"></i>
                        </Button>
                      </OverlayTrigger>
                    </>
                  )}
                  {hasPermission('M15S2B2') && (
                    <>
                      {this.state.activeTab === "self" && rowData.status === "Pending" && (
                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit Details</Tooltip>}>
                          <Button size="sm" variant="outline-info" className="mr-2 info" onClick={() => this.handleEditClick(rowData)}>
                            <i className="far fa-edit"></i>
                          </Button>
                        </OverlayTrigger>
                      )}
                    </>
                  )}
                  {hasPermission('M15S2B5') && (
                    <>
                      {this.state.activeTab === "self" && rowData.status !== "Rejected" && (
                        <OverlayTrigger placement="top" overlay={<Tooltip>Download PDF</Tooltip>}>
                          <Button size="sm" className='mr-2 info' variant="outline-info" onClick={() => this.handlePdfDownload(rowData, "self")}>
                            <i className="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      )}
                    </>
                  )}
                  {hasPermission('M15S2B3') && (
                    <>
                      {this.state.activeTab === "reportee" && rowData.status === "Pending" && (
                        <OverlayTrigger placement="top" overlay={<Tooltip>Update Status</Tooltip>}>
                          <Button size="sm" variant="outline-info" className="mr-2 info" onClick={() => this.handleStatusChange(rowData)}>
                            <i className="fas fa-sync-alt"></i>
                          </Button>
                        </OverlayTrigger>
                      )}
                    </>)}
                  {hasPermission('M15S2B4') && (
                    <>
                      {this.state.activeTab === "reportee" && rowData.status !== "Rejected" && (
                        <OverlayTrigger placement="top" overlay={<Tooltip>Download Pdf</Tooltip>}>
                          <Button size="sm" variant="outline-info" className="mr-2 info" onClick={() => this.handlePdfDownload(rowData, "reportee")}>
                            <i className="fas fa-file-pdf"></i>
                          </Button>
                        </OverlayTrigger>
                      )}
                    </>)}
                  {hasPermission('M15S2B6') && (
                    <>
                      {(rowData?.status === 'Pending' &&
                        (rowData?.total_amount === 0 && rowData?.status !== 'Approved')) && (
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Delete Expense Header</Tooltip>}
                          >
                            <Button
                              size="sm"
                              variant="outline-danger"
                              className="mr-2 delete-btn"
                              onClick={() => this.setState({ showConfirm: true, deleteId: rowData.id })}
                            >
                              <i className="fas fa-trash"></i>
                            </Button>
                          </OverlayTrigger>
                        )}
                    </>
                  )}
                </>
              ),
              cellStyle: { width: '200px', minWidth: '200px', textAlign: 'center' }, // Adjust width as needed
              headerStyle: { width: '200px', minWidth: '200px', textAlign: 'center' }
            },
          ]
          }
          data={expenses}
          options={{
            search: true, // ✅ Enables search
            rowStyle: (rowData, index) => index % 2 ? { backgroundColor: "#f2f2f2" } : {},
            pageSize: 10,
            pageSizeOptions: [10, 20, 30, 50, 75, 100],
          }}
          title="Expense Headers"
        />
      </ThemeProvider >
    );
  };

  render() {

    return (
      <div className="container-fluid pt-4">
        <CommonToast show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <ConfirmModal
          show={this.state.showConfirm}
          onHide={() => this.setState({ showConfirm: false, deleteId: null })}
          onConfirm={() => this.handleDelete()}
          title="Delete Confirmation"
          loading={this.state.loading}
          message="Are you sure you want to delete this Expense Header?"
        />
        <CommonLoader isLoading={this.state.loading}>
          {hasPermission('M15S1') && (
            <div className='add-role'>
              <Button variant="primary" className="d-flex align-items-center gap-2 
              px-4 py-2 rounded-pill shadow-sm custom-add-button"
                onClick={this.handleAddExpense}> <i className="fa fa-plus-circle"></i> Add Expense Header</Button>
            </div>
          )}
          <div className="container-fluid pt-2">
            <Tab.Container activeKey={this.state.activeTab} onSelect={this.handleTabChange}>
              <Nav variant="tabs">
                <Nav.Item>
                  <Nav.Link eventKey="self">Self</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="reportee">Reportee</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content className="mt-3">
                <Tab.Pane eventKey="self">{this.renderTable(this.state.selfExpenses)}</Tab.Pane>
                <Tab.Pane eventKey="reportee">{this.renderTable(this.state.reporteeExpenses)}</Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
          <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Update Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group>
                  <Form.Label className="required">Select Status</Form.Label>
                  <Form.Control
                    as="select"
                    className="form-select"
                    value={this.state.newStatus}
                    onChange={(e) => this.setState({ newStatus: e.target.value })}
                  >
                    <option value="">Select</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </Form.Control>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={() => this.setState({ showModal: false })} size="sm">
                Cancel
              </Button>
              <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={this.handleStatusUpdate} size="sm">
                Update
              </Button>
            </Modal.Footer>
          </Modal>
        </CommonLoader>

        {this.state.showPdfComponent && this.state.pdfData && (
          <ExpenseVoucherPDF
            key={Date.now()}
            data={this.state.pdfData}
            expenseDetails={this.state.expDataByExpId}
            empType={this.state.empType}
            pendingAmount={this.state.pendingAmount}
            onComplete={() => this.setState({
              pdfData: null,
              showPdfComponent: false,
              isGeneratingPDF: false
            })}
          />
        )}
      </div>
    );
  }
}
